import React from 'react'
//import { channels } from '../../config/constant'
import { errorMsg } from '../../config/constant'
import './tvChannels.css'
import {
  //currentChannelAction,
  //fetchChannelList,
  //getremoteAccessToken,
  //setTvToken,
  popupOpenClose,
  setTVConformPage,
  setDeviceLoginPage
} from '../../action/action'
import {
  currentChannelAction,
  fetchChannelList,
  getremoteAccessToken,
  //setTvToken,
  setCurrentTV,
  fetchIPTVChannelList,
  setNextTV
} from '../../action/tvChannelAction'
import {
  playOnTV,
  playPrivous,
  playNext,
  makeMove

} from './channelController'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { heightFix } from '../../JS/heightFix'
import { setTVControlColor } from '../../JS/setColors'
import { setWebViewOnWidgetStart } from '../../JS/setWebView'

class Channels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentActive: 0,
      channelClick: false,
      touch: false,
      channelListWidth: 250
    }
  }

  componentDidMount() {
    //heightFix();
    //setWebViewOnWidgetStart();
    let listWidth = document.getElementById("channelListThumbs").parentElement.clientWidth
    console.log("width", listWidth);
    this.setState({ channelListWidth: listWidth });
    setTVControlColor(this.props.menuColor);
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    let room = localStorage.getItem("room");
    let chanSchHours = parseInt(this.props.channelScheduleHours);
    if (sessionToken && this.props.guestDetail.locationId && this.props.guestDetail.guestToken) {
      if (this.props.TVType === "IPTV") {
        if (!this.props.currentTv.remoteSessionToken) {
          this.props.getremoteAccessToken(this.props.roomRemoteDetails, this.callBackForColor);
        }
        this.props.fetchIPTVChannelList(sessionToken);
      } else if (chanSchHours) {
        if (!this.props.currentTv.remoteSessionToken) {
          this.props.getremoteAccessToken(this.props.roomRemoteDetails, this.callBackForColor);
        }
        this.props.fetchChannelList("/Ipg/ChannelData", chanSchHours, sessionToken);
      }

    } else {
      console.log("no session token.");
      if (this.props.currentWidget.widgetType && !room || room === "null") {
        this.props.setDeviceLoginPage(true);
        console.log("room", room);
      } else {
        console.log("there is some bug in guest registration flow.")
      }
    }
  }

  callBackForColor = () => {
    console.log("call back.");
    setTimeout(() => {
      setTVControlColor(this.props.menuColor);
    }, 500);
  }

  getToken = () => {
    let token = null
    if (this.props.roomRemoteDetails.length > 0) {
      if (!this.props.currentTv.remoteSessionToken) {
        // this.props.roomRemoteDetails.map((iterator, index) => {
        //   if (iterator.deviceName === this.props.cuurentTV) {
        //     token = iterator.remoteSessionToken
        //     this.props.setTvToken(iterator.remoteSessionToken);
        //   }
        // })
        if (this.props.roomRemoteDetails.length === 1) {
          this.props.setCurrentTV(this.props.roomRemoteDetails[0]);
          token = this.props.roomRemoteDetails[0].remoteSessionToken
        } else {
          this.props.popupOpenClose(true, "Please select your TV In TV section.");
        }
      } else {
        token = this.props.currentTv.remoteSessionToken
      }
    } else {
      this.props.popupOpenClose(true, "No TVs to control are found.");
      console.log("No TVs to control are found");
    }
    //console.log('getToken', token);
    return token
  }
  onChannelClick = (currentCh, index) => {
    if (this.props.guestInRoom) {
      if (!this.state.channelClick) {
        let token = this.getToken();
        if (token) {
          this.setState({ currentActive: index })
          this.props.currentChannelAction(currentCh)
          playOnTV(token, currentCh.channelNumber);
          this.setState({ channelClick: true })
          window.setTimeout(() => {
            this.setState({ channelClick: false })
          }, 2000);
        }
      }
    } else {
      this.props.popupOpenClose(true, errorMsg);
    }
  }

  onChannelClickMobile = (event) => {
    if (this.props.guestInRoom) {
      let token, currentCh
      let channelNumber = parseInt(event.target.value);
      this.props.channelData.map((iterator, index) => {
        if (channelNumber === index) {
          this.props.currentChannelAction(iterator)
          currentCh = iterator.channelNumber
        }
        return 0;
      })
      token = this.getToken();
      if (token) {
        console.log("roomRemoteDetails", token, currentCh);
        if (!this.state.channelClick) {
          playOnTV(token, currentCh);
          this.setState({ channelClick: true })
        }
        window.setTimeout(() => {
          this.setState({ channelClick: false })
        }, 2000);
      }
    } else {
      this.props.popupOpenClose(true, errorMsg);
    }
  }

  sendCommand = (command) => {
    // console.log("sendCommand")
    setTVControlColor(this.props.menuColor);
    let token = this.getToken()
    if (token) {
      makeMove(token, command);
    }
  }

  onTVSelect = (TVdata, touch) => {
    console.log("click found");
    if (!this.state.touch && touch) {
      this.setState({ touch: true })
    }
    if (this.state.touch) {
      if (touch) {
        console.log("touch found");
        if (this.props.currentTv.remoteSessionToken) {
          if (this.props.currentTv.remoteSessionToken === TVdata.remoteSessionToken) {
            console.log("same TV.");
          } else {
            this.props.setTVConformPage(true);
            this.props.setNextTV(TVdata);
          }
        } else {
          this.props.setCurrentTV(TVdata);
        }
      }
    } else {
      this.props.setCurrentTV(TVdata);
    }
  }
  /*
  currentschedule = () => {    
    let date = new Date();
    let day = date.getDay();
    let hours = date.getHours();
    let min = date.getMinutes();
    let startTime;
    this.state.currentChannel.schedules.map((iterator,index)=>{
      startTime = iterator.startTime;
      console.log("date is ",startTime.slice(8,9))
      return 0;
    })
    return (
      <div>
        schedules
      </div>
    )
  }
*/
  render() {
    let Image = this.props.currentChannel.iconUrl
    return (
      <div
        id="tv-ctl"
        className="contentSection">
        <div className="columns" style={{ background: "rgba(255,255,255,0.95)" }}>
          <div
            className="col col-2 h-100 m-r25"
            style={{
              background: 'rgba(255,255,255,0.95)',
              marginRight: 0,
              overflowY: 'auto'
            }}>
            <div className="tv-controls">
              <div className="tv-buttons center" style={{ color: "#fff" }}>
                <p className="my-label">Main</p>
                <a onClick={() => { this.sendCommand(["POWER"]) }} className="button w-100"><i className="fa fa-power-off"></i> Power on/off</a>
                <a className="button w-49" onClick={() => { this.sendCommand(["HOME"]) }}><i className="fa fa-home"></i> Home</a>
                <a className="button w-49" onClick={() => { this.sendCommand(["MENU"]) }} style={{ marginLeft: "5px" }}><i className="fa fa-list"></i> Menu</a>
              </div>
              <div className="tv-buttons center" style={{ color: "#fff" }}>
                <p className="my-label">TV Selection</p>
                {
                  this.props.roomRemoteDetails.length > 0 ?
                    this.props.roomRemoteDetails.map((iterator, index) => {
                      return (
                        <a
                          className={
                            this.props.currentTv.remoteSessionToken === iterator.remoteSessionToken ?
                              "button w-49 selected" : "button w-49"}
                          style={index % 2 === 0 ? {} : { marginLeft: "5px" }
                          }
                          onClick={() => { this.onTVSelect(iterator, false) }}
                          onTouchStart={() => { this.onTVSelect(iterator, true) }}
                        >
                          <i className="fa fa-tv"></i>
                          {iterator.deviceName !== "null" ? iterator.deviceName : index === 0 ? " TV" : ` TV ${index}`}
                        </a>
                      )
                    }) : <div style={{ color: "red", fontWeight: "bold" }}> "NO TV IS CONNECTED."</div>
                }
              </div>
              <div className="tv-buttons center" style={{ color: "#fff" }}>
                <p className="my-label">Keyboard</p>
                <a className="button w-100 open-vk"><i className="fa fa-keyboard-o"></i> Open Keyboard</a>
              </div>
            </div>
          </div>
          <div
            id="control-options"
            className="col col-2 h-100 results-col"
            style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div className="tv-controls">
              <div className="tv-buttons center" style={{ color: "#fff" }}>
                <p className="my-label">Navigation</p>
                <div className="center" style={{ color: "#fff" }}>
                  <a className="button w-25" onClick={() => { this.sendCommand(["UP"]) }}>
                    <i className="fa fa-chevron-up"></i>
                  </a>
                </div>
                <div className="center" style={{ color: "#fff" }}>
                  <a className="button w-25" onClick={() => { this.sendCommand(["LEFT"]) }}>
                    <i className="fa fa-chevron-left"></i>
                  </a>
                  <a className="button w-25" onClick={() => { this.sendCommand(["ENTER"]) }} style={{ marginLeft: "5px" }}>
                    <i className="fa fa-dot-circle-o"></i>
                    <span className="ok-text"> OK</span>
                  </a>
                  <a className="button w-25" onClick={() => { this.sendCommand(["RIGHT"]) }} style={{ marginLeft: "5px" }}>
                    <i className="fa fa-chevron-right"></i>
                  </a>
                </div>
                <div className="center" style={{ color: "#fff" }}>
                  <a className="button w-25" onClick={() => { this.sendCommand(["DOWN"]) }}><i className="fa fa-chevron-down"></i></a>
                </div>
              </div>
              <div className="tv-buttons center" style={{ color: "#fff" }}>
                <p className="my-label">Channel and volume</p>
                <a className="button w-45" onClick={() => { this.sendCommand(["CH_UP"]) }}>CH <i className="fa fa-chevron-up"></i></a>
                <a className="button w-45" onClick={() => { this.sendCommand(["CH_DOWN"]) }} style={{ marginLeft: "5px" }}>CH <i className="fa fa-chevron-down"></i></a>
              </div>
              <div className="tv-buttons center" style={{ color: "#fff" }}>
                <a className="button w-40" onClick={() => { this.sendCommand(["MUTE"]) }}><i className="fa fa-volume-off"></i> Mute</a>
                <a className="button w-25" onClick={() => { this.sendCommand(["VOL_UP"]) }} style={{ marginLeft: "5px" }}><i className="fa fa-volume-up"></i></a>
                <a className="button w-25" onClick={() => { this.sendCommand(["VOL_DOWN"]) }} style={{ marginLeft: "5px" }}><i className="fa fa-volume-down"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div className="columns" style={{ background: "rgba(255,255,255,0.95)", marginTop: "1rem" }}>
          <div className="channel-list">
            {/* <div className="w-15 ch-list-nav">
              <a className="nav-left"><i className="fa fa-chevron-left"></i></a>
            </div> */}
            <div className="ch-list-gallery">
              <div className="ch-list-title">Channel list</div>
              <div className="ch-list-thumbs"
                id="channelListThumbs"
                style={
                  {
                    overflow: "auto", whiteSpace: "nowrap", marginLeft: "1.5rem", marginRight: "1.5rem",
                    paddingBottom: "1.5rem", width: `${this.state.channelListWidth - 46}px  `
                  }
                }>
                <ul>
                  {
                    Array.isArray(this.props.channelData) ?
                      this.props.channelData.map((iterator, index) => {
                        return (
                          <li onClick={() => { this.onChannelClick(iterator, index) }}>
                            <div className="ch-thumb"
                              style={{
                                background: `url('${iterator.iconUrl}') center center no-repeat;background-size: cover`,
                                background: 'rgba(204, 204, 204, 0.3)',
                                backgroundImage: `url('${iterator.iconUrl}')`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center'
                              }}
                            ></div>
                            <div className="ch-name">{iterator.channelName || "UNKNOWN"}</div>
                          </li>
                        )
                      }) : ""
                  }
                </ul>
              </div>
            </div>
            {/* <div className="w-15 ch-list-nav">
              <a className="nav-right"><i className="fa fa-chevron-right"></i></a>
            </div> */}
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = state => {
  return {
    channelData: state.store.tvChannels.channelData,
    currentChannel: state.store.tvChannels.currentChannel,
    stringConst: state.store.home.stringConst,
    channelScheduleHours: state.store.home.clientConfig.ipgExtraInfo ?
      state.store.home.clientConfig.ipgExtraInfo.ipgBrandingInfo.channelScheduleHours : "0",
    roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
    guestInRoom: state.store.guestInRoom,
    currentTv: state.store.tvChannels.currentTv,
    TVType: state.store.tvChannels.TVType,
    menuColor: state.store.home.MenuColor,
    guestDetail: state.store.home.guestDetails,
    currentWidget: state.store.sideNavBar.currentWidget
  }
}

Channels.propTypes = {
  channelData: PropTypes.arrayOf(PropTypes.object),
  currentChannel: PropTypes.object,
  stringConst: PropTypes.object,
  channelScheduleHours: PropTypes.string,
  roomRemoteDetails: PropTypes.object,
  currentTv: PropTypes.string,
}

Channels.defaultProps = {
  channelData: [{}],
  currentChannel: {}
}
export default connect(
  mapStateToProps,
  {
    currentChannelAction,
    fetchChannelList,
    getremoteAccessToken,
    //setTvToken,
    popupOpenClose,
    setCurrentTV,
    fetchIPTVChannelList,
    setTVConformPage,
    setNextTV,
    setDeviceLoginPage
  }
)(Channels);
